"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTABLE_HISTORIAL_BLOQ_1_COLUMNS_MAP = void 0;
exports.SORTABLE_HISTORIAL_BLOQ_1_COLUMNS_MAP = {
    id: 'log_id',
    ani: 'log_ani',
    accion: 'log_accion',
    responsable: 'log_responsable',
    empresa_del_responsable: 'log_resp_empresa',
    motivo: 'log_motivo',
    fecha_bloqueo: 'log_fecha_doc',
    fecha_accion: 'log_fecha',
};
